module.exports = __webpack_public_path__ + "img/decimmo_logo.1ca7f732.png";